import axios from 'axios'
import Element from 'element-ui'
import router from './router'

import store from './store'


axios.defaults.baseURL = "https://trace.csgpower.com.cn:8089/BMS"
// axios.defaults.baseURL = "http://116.236.94.75:8084/BMS"//股份服务器地址
// axios.defaults.baseURL = "http://10.10.8.89:8089/BMS" //秦
// axios.defaults.baseURL = "http://10.10.31.201:8089/BMS" //赵


// axios.defaults.baseURL = "http://10.10.8.114:8089/BMS" //李
// axios.defaults.baseURL = "http://10.10.1.163:8089/BMS" //生产

const request = axios.create({
  // baseURL: '/api', //解决本地接口跨域
  // timeout: 5000,
  headers: {
    'Content-Type': "application/json; charset=utf-8"
  }
})


request.interceptors.request.use(config => {
  config.headers['Authorization'] = localStorage.getItem("token")
  return config
})

request.interceptors.response.use(
  response => {
    return response
    // let res = response.data
    
    // if (res.code === 200) {
    //   return response
    // } else {
    //   Element.Message.error(!res.msg ? '系统异常' : res.msg)
    //   return Promise.reject(response.data.msg)
    // }
  },
  error => {

    if (!error.response) {

    } else {
      if (error.response.data) {
        // error.massage = error.response.data.msg
      } 
      if (error.response.status === 401) {
        error.massage = '请重新登录'
        localStorage.setItem("token", null);
        router.push("/login")
      } 
    }
    
    Element.Message.error(error.massage?error.massage:'网络错误，请稍候重试。', {
      duration: 3000
    })
 
    return Promise.reject(error)
  }
)

export default request
